import Chart from "react-google-charts";
import React, { Component } from 'react';
import DBService from '../../service/DBService';
//import MediaQuery from 'react-responsive';

class TreeMap extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true
    }
  }

  componentDidMount() {
    DBService.getSp500HeatMap()
      .then(result => {
        result = result.data;
        console.log('getHeatMap', result);

        let filteredData = [];
        filteredData.push(['Symbol', 'Sector', 'Changes', 'Price', { role: 'tooltip' }]);
        filteredData.push(['S&P 500', null, 0, 0, '']);
        filteredData.push(['Communication Services', 'S&P 500', 0, 0, '']);
        filteredData.push(['Energy', 'S&P 500', 0, 0, '']);
        filteredData.push(['Technology', 'S&P 500', 0, 0, '']);
        filteredData.push(['Industrials', 'S&P 500', 0, 0, '']);
        filteredData.push(['Financial Services', 'S&P 500', 0, 0, '']);
        filteredData.push(['Basic Materials', 'S&P 500', 0, 0, '']);
        filteredData.push(['Consumer Cyclical', 'S&P 500', 0, 0, '']);
        filteredData.push(['Consumer Defensive', 'S&P 500', 0, 0, '']);
        filteredData.push(['Healthcare', 'S&P 500', 0, 0, '']);
        filteredData.push(['Utilities', 'S&P 500', 0, 0, '']);
        filteredData.push(['Real Estate', 'S&P 500', 0, 0, '']);
        filteredData.push(['Financial', 'S&P 500', 0, 0, '']);

        for (var i = 0; i < result.length; i++) {
          let colorValue = 10;
          if (result[i].changesPercentage >= 3) {
            colorValue = 10;
          } else if (result[i].changesPercentage > 1 && result[i].changesPercentage <= 2) {
            colorValue = 12;
          } else if (result[i].changesPercentage >= 0 && result[i].changesPercentage <= 1) {
            colorValue = 14;
          } else if (result[i].changesPercentage < 0 && result[i].changesPercentage >= -1) {
            colorValue = 18;
          } else if (result[i].changesPercentage < -1 && result[i].changesPercentage >= -2) {
            colorValue = 19;
          } else if (result[i].changesPercentage <= -3) {
            colorValue = 20;
          }
          let text = '', tooltip = '';
          if (result[i].changesPercentage < 0) {
            result[i].changesPercentage = -1 * result[i].changesPercentage;
            text = result[i].symbol + ' : -' + parseFloat(result[i].changesPercentage).toFixed(2) + '%';
            tooltip = result[i].symbol + ' : -' + parseFloat(result[i].changesPercentage).toFixed(2) + '%' + result[i].name;
          } else {
            text = result[i].symbol + ' : ' + parseFloat(result[i].changesPercentage).toFixed(2) + '%';
            tooltip = result[i].symbol + ' : ' + parseFloat(result[i].changesPercentage).toFixed(2) + '%' + result[i].name;
          }

          filteredData.push([text, result[i].sector, result[i].changesPercentage, colorValue, tooltip]);
        }
        this.setState({ data: filteredData, loading: false});
        console.log('filteredData', filteredData);
      })
      .catch((error) => {
        console.log(error);
      });

  }

  showFullTooltip(row, size, value) {
    // return '<div style="background:#fd9; padding:10px; border-style:solid">' +
    //   '<span style="font-family:Courier"><b>' + data.getValue(row, 0) +
    //   '</b>, ' + data.getValue(row, 1) + ', ' + data.getValue(row, 2) +
    //   ', ' + data.getValue(row, 3) + '</span><br>' +
    //   'Datatable row: ' + row + '<br>' +
    //   data.getColumnLabel(2) +
    //   ' (total value of this cell and its children): ' + size + '<br>' +
    //   data.getColumnLabel(3) + ': ' + value + ' </div>';
    return '<div style="background:#fd9; padding:10px; border-style:solid">' +
      '<span style="font-family:Courier"><b>' + size + '</span><br>' +
      ' </div>';
  }

  render() {
    if (this.state === null) {
      return <div>Loading...</div>
    }
    if (this.state.data === null || this.state.data.length <= 0) {
      if (this.state.loading){
        return <div>Loading...</div>
      } else{
        return <div>No Data</div>
      }
    }
  
    return (
      <Chart
      // width={'1350px'}
      height={'550px'}
      chartType="TreeMap"
      loader={<div>Loading Chart</div>}
      data={this.state.data}
      options={{
        minColor: 'darkgreen',
        midColor: 'lightgreen',
        maxColor: 'red',
        //noColor: 'lime',
        headerHeight: 15,
        fontColor: 'black',
        showScale: false,
        maxDepth: 2,
        showTooltips: true,
        //generateTooltip: this.showFullTooltip
      }}
      rootProps={{ 'data-testid': '4' }}
    />
    );
  }
}

export default TreeMap;

